import NetworkProvider from '../Provider';

const getProfile = async () => {
  return NetworkProvider().get('/api/v1/users/me');
};

export {
  getProfile
}